export const installationListFormData = () => ({
  inputData: {
    form_name: "",
    created_by: 1,
    is_active: true,
    installations: {},
    list_details: [],
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "outwards",
    whereCondition: {
      is_active: true,
    },
    relation: [
      {
        modelName: "outward_items",
        moduleAs: "outward_items",
        foreignKey: "outward_id",
      },
    ],
  };

  const navigatePage = { back: "/installationlist-list" };

  const headerName = "Outward";

  const validationType = "OutwardCreate";
  const createEndpoint = "/createOutward";
  const getEndpoint = "/getOutwardById";
  const typeSelectOptions = [
    { label: "Outward", value: "Outward" },
    { label: "MRB", value: "MRB" },
    { label: "Scrab", value: "Scrab" },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getEndpoint,
    typeSelectOptions,
  };
};

export const exportPageData = {
  data: {
    modelName: "installation_commissioning_list_masters",
    listInstallation: true,
    contractor_id: null,
    assignedTo: null,
    status: "installation_completed",

    search: {
      searchKeyword: "",
      field_name: ["warehouse.warehouse_name", "contractor.first_name"],
    },
    pagination: { page: 1, pageSize: 100000 },
  },
  fileName: "installationListData.xlsx",
};
